import selectConversationSortOrderOption from '../actions/selectConversationSortOrderOption';
import selectHideDeletedItemsOption from '../actions/selectHideDeletedItemsOption';
import selectGlobalListViewTypeOption from '../actions/selectGlobalListViewTypeOption';
import ConversationsOptionState from '../store/schema/ConversationsOptionState';
import store from '../store/store';
import { ChoiceGroupWithImages } from 'owa-choice-group-with-images';
import { getFallbackValueIfNull } from 'owa-options-core';
import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

const NEWEST_ON_TOP_SVG = require('./newestTopLarge.svg');
const NEWEST_ON_BOTTOM_SVG = require('./newestBottomLarge.svg');
const HIDE_DELETED_ITEMS_SVG = require('./hideDeletedLarge.svg');
const SHOW_DELETED_ITEMS_SVG = require('./showDeletedLarge.svg');

export interface ConversationsFullProps {
    userOptions?: UserOptionsType;
    optionState?: ConversationsOptionState;
}

@reactive({
    userOptions: () => getUserConfiguration().UserOptions,
    optionState: () => store,
})
export default class ConversationsFull extends React.Component<ConversationsFullProps, {}> {
    render() {
        let { userOptions, optionState } = this.props;

        let listViewTypeSelectedKey = getFallbackValueIfNull(
            optionState.globalListViewType,
            userOptions.GlobalListViewTypeReact
        );
        let conversationSortOrderKey =
            optionState.conversationSortOrder || userOptions.ConversationSortOrderReact;
        let hideDeletedItemsKey = `${getFallbackValueIfNull(
            optionState.hideDeletedItems,
            userOptions.HideDeletedItems
        )}`;

        return (
            <div>
                {
                    <ChoiceGroup
                        selectedKey={`${listViewTypeSelectedKey}`}
                        label={strings.options_messageOrganization_positionLabel}
                        options={[
                            {
                                key: `${ReactListViewType.Conversation}`,
                                text: strings.options_messageOrganization_showAsConversation,
                            },
                            {
                                key: `${ReactListViewType.Message}`,
                                text: strings.options_messageOrganization_showAsMessage,
                            },
                        ]}
                        onChange={this.onListViewTypeChange}
                    />
                }
                {listViewTypeSelectedKey === ReactListViewType.Conversation && [
                    <ChoiceGroupWithImages
                        key="sortOrder"
                        selectedKey={conversationSortOrderKey}
                        label={strings.options_conversations_sortOrderLabel}
                        options={[
                            {
                                key: 'ChronologicalNewestOnTop',
                                text: strings.options_conversations_sortOrderTop,
                                imageUri: NEWEST_ON_TOP_SVG,
                                width: 280,
                            },
                            {
                                key: 'ChronologicalNewestOnBottom',
                                text: strings.options_conversations_sortOrderBottom,
                                imageUri: NEWEST_ON_BOTTOM_SVG,
                                width: 280,
                            },
                        ]}
                        onChange={this.onChangeSortOrder}
                    />,
                    <ChoiceGroupWithImages
                        key="deletedItems"
                        selectedKey={hideDeletedItemsKey}
                        label={strings.options_conversations_deletedItemsLabel}
                        options={[
                            {
                                key: 'false',
                                text: strings.options_conversations_deletedItemsShow,
                                imageUri: SHOW_DELETED_ITEMS_SVG,
                                width: 280,
                            },
                            {
                                key: 'true',
                                text: strings.options_conversations_deletedItemsHide,
                                imageUri: HIDE_DELETED_ITEMS_SVG,
                                width: 280,
                            },
                        ]}
                        onChange={this.onHideDeletedItemsChanged}
                    />,
                ]}
            </div>
        );
    }

    private onListViewTypeChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectGlobalListViewTypeOption(+option.key as ReactListViewType);
    };

    private onHideDeletedItemsChanged = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectHideDeletedItemsOption(option.key === 'true');
    };

    private onChangeSortOrder = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectConversationSortOrderOption(option.key as ConversationSortOrder);
    };
}
